/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const SendExampleSurvey = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 20 19">
    <g id="UX-Specification-document" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Reports-page" transform="translate(-52.000000, -1197.000000)" fill="#3D3D36" fillRule="nonzero">
        <g id="Send-Example-Survey" transform="translate(52.000000, 1197.000000)">
          <path
            d="M19.77,0.87 C19.7852226,0.787361845 19.7852226,0.702638155 19.77,0.62 L19.77,0.57 C19.7346068,0.482295475 19.6799212,0.40368503 19.61,0.34 C19.5354633,0.289646192 19.4495286,0.258709707 19.36,0.25 L19.3,0.25 C19.2034334,0.24958801 19.1079188,0.270055417 19.02,0.31 L0.52,10.3 C0.300038569,10.426121 0.171774492,10.667102 0.19,10.92 C0.211915824,11.1722522 0.38048835,11.3878682 0.62,11.47 L6.81,13.55 L6.81,18.27 C6.81184134,18.5525917 6.99880773,18.8005254 7.27,18.88 C7.33296915,18.8896052 7.39703085,18.8896052 7.46,18.88 C7.67015233,18.8905021 7.87204087,18.7970352 8,18.63 L10.64,14.83 L16.07,16.66 C16.2451695,16.7215277 16.4384247,16.703955 16.5996236,16.6118413 C16.7608225,16.5197277 16.8740763,16.3621524 16.91,16.18 L19.77,0.93 L19.77,0.88 L19.77,0.87 Z M18.08,3 L15.77,15.21 L9.14,13 L18.08,3 Z M16.18,3.2 L7.82,12.54 L2.42,10.72 L16.18,3.2 Z M9.35,14.41 L8.1,16.22 L8.1,14 L9.35,14.41 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default SendExampleSurvey
